import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import { forwardRefWithAs } from '@stacks/ui-core';
import { Box } from './box/index.esm.js';

var VisuallyHidden = /*#__PURE__*/forwardRefWithAs(function (props, ref) {
  return /* @__PURE__ */createElement(Box, _extends({
    border: 0,
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute",
    clip: "rect(0px, 0px, 0px, 0px)",
    ref: ref
  }, props));
});

export { VisuallyHidden };
//# sourceMappingURL=visually-hidden.esm.js.map
